'use client'

import { Nunito } from 'next/font/google'
import './global.css'
import 'react-leaflet-fullscreen/styles.css'
import 'leaflet/dist/leaflet.css'
import { SpeedInsights } from '@vercel/speed-insights/next'
import Modal from '@/components/Modal'
import PwaInstallPrompt from '@/components/PwaInstallPrompt'
import LayoutWrapper from './layout-wrapper'
import NProgressBar from '@/components/NProgressBar'

const nunitoFont = Nunito({
    subsets: ['latin'],
    display: 'swap',
})

import { SWRConfig } from 'swr'
import useAxiosInstance from '@/lib/axios'
import { Toaster } from 'react-hot-toast'
import { useEffect, useMemo } from 'react'

const RootLayout = ({ children }) => {
    const axios = useAxiosInstance()

    useEffect(() => {
        if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
            return
        }

        navigator.serviceWorker.register('/sw.js').catch(error => {
            // Keep this visible in devtools when registration fails.
            console.error('Service worker registration failed:', error)
        })
    }, [])

    return (
        <html
            lang="en"
            className={nunitoFont.className}
            suppressHydrationWarning>
            <head>
                <meta name="theme-color" content="#2563eb" />
                <meta name="application-name" content="DASURECO Dashboard" />
                {/* <meta name="mobile-web-app-capable" content="yes" /> */}
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <link rel="manifest" href="/manifest.webmanifest" />
                <meta
                    name="apple-mobile-web-app-title"
                    content="DASURECO Dashboard"
                />
                <link rel="manifest" href="/manifest.webmanifest" />
                {/* <link rel="icon" href="/icon" sizes="512x512" /> */}
                <link rel="icon" href="/icon-192.png" />
                <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
                <link rel="apple-touch-icon" href="/apple-icon" />
                {/* Inline script to apply dark mode before first paint, preventing flash */}
                <script
                    dangerouslySetInnerHTML={{
                        __html: `(function(){try{var s=localStorage.getItem('darkMode');var prefersDark=window.matchMedia('(prefers-color-scheme: dark)').matches;var isDark=s!==null?JSON.parse(s):prefersDark;if(isDark)document.documentElement.classList.add('dark');}catch(e){}})();`,
                    }}
                />
                <link
                    rel="stylesheet"
                    href="https://unpkg.com/leaflet@1.8.0/dist/leaflet.css"
                    integrity="sha512-hoalWLoI8r4UszCkZ5kL8vayOGVae1oxXe/2A4AO6J9+580uKHDO3JdHb7NzwwzK5xr/Fs0W40kiNHxM9vyTtQ=="
                    crossOrigin=""
                />

                <script
                    src="https://unpkg.com/leaflet@1.8.0/dist/leaflet.js"
                    integrity="sha512-BB3hKbKWOc9Ez/TAwyWxNXeoV9c1v6FIeYiBieIWkpLjauysF18NzgR1MBNBXf8/KABdlkX68nAhlwcDFLGPCQ=="
                    crossOrigin=""
                    async
                    defer></script>
                {/* Debug style for ProgressBar */}
                <style>{`.nprogress-bar { z-index: 9999 !important; background: #ff0000 !important; }`}</style>
            </head>
            <body className="antialiased">
                <Toaster position="top-right" />
                <LayoutWrapper>
                    <SWRConfig
                        value={useMemo(
                            () => ({
                                fetcher: url =>
                                    axios.get(url).then(res => res.data),
                                revalidateOnFocus: false,
                                revalidateOnReconnect: false,
                                refreshInterval: 0,
                            }),
                            [axios],
                        )}>
                        {children}
                    </SWRConfig>
                </LayoutWrapper>

                <NProgressBar />
                {/* <SpeedInsights /> */}
                <Modal />
                <PwaInstallPrompt />
            </body>
        </html>
    )
}

export default RootLayout
